import { apiDelete, apiPatch, apiPost } from "src/helpers/axios/config";
import utils from "src/helpers/Utils";
import { FeedbackSchemaType } from "src/schemas/feedbackSchema";

class FeedbackService {
    private readonly url = "feedbacks";

    async updateFeedback({
        id,
        ...feebackInfo
    }: FeedbackSchemaType & {
        id: string;
    }) {
        const data: { [key: string]: any } = {};
        Object.keys(feebackInfo).forEach(key => {
            if (!utils.checkIsNullOrUndefined(feebackInfo[key]))
                data[key] = feebackInfo[key];
        });

        return apiPatch({ apiPath: `${this.url}/${id}`, data });
    }
}

export const feedbackService = new FeedbackService();
